import React from 'react';
import PropTypes from 'prop-types';
import startCase from 'lodash/startCase';
import cn from 'classnames';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';

const Tabs = ({ options, active, rounded, onClick, className }) => {
  const { t } = useTranslation(['operational']);
  return (
    <div className={cn(styles.container, className)}>
      {options.map((option, k) => (
        <div
          className={cn(
            { [styles.rounded]: rounded },
            { [styles.active]: option === active },
            styles.tab,
          )}
          key={k}
          onClick={() => onClick(option)}
        >
          {t(startCase(option))}
        </div>
      ))}
    </div>
  );
};

Tabs.propTypes = {
  options: PropTypes.array.isRequired,
  active: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  rounded: PropTypes.bool,
  className: PropTypes.string,
};

Tabs.defaultProps = {
  rounded: true,
};

export default Tabs;
